import React, {useEffect, useState} from 'react';
import Loading from "../../layout/Loading";
import {useEyeconxStore} from '../../../../store/eyeconxStore';
import {toast} from 'react-toastify';
import settingsService from '../../../../services/settings.service';
import GatewayClinicInfoForm from './GatewayClinicInfoForm';
import GatewayClinicInfoText from './GatewayClinicInfoText';

function GatewayClinicInfo() {
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [clinicInfo, setClinicInfo] = useState(null);
    const clinicId = useEyeconxStore(state => state.user.clinicId);

    useEffect(() => {
        getClinicInfo();
    }, [clinicId]);

    const getClinicInfo = () => {
        setIsLoading(true);
        settingsService.getClinicById(clinicId)
            .then(res => {
                setClinicInfo(res.data);
                setIsLoading(false);
            })
            .catch(err => {
                console.error("Error while getting Clinic Info", err);
                setIsLoading(false);
                toast.error("Failed to load clinic information", {
                    position: "bottom-right"
                });
            });
    };

    const updateClinicInfo = (data) => {
        setIsLoading(true);
        settingsService.updateClinic(clinicId, data)
            .then(res => {
                setClinicInfo(data);
                toast.success("Clinic information updated successfully", {
                    position: "bottom-right"
                });
                setIsEditing(false);
            })
            .catch(err => {
                console.error("Error while updating Clinic", err);
                toast.error("Failed to update clinic information", {
                    position: "bottom-right"
                });
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div className="container mt-4">
            <div className="row">
                {/* Main Content Area - col-9 */}
                <div className="col-md-9">
                    <div className="card shadow mb-1">
                        <div className="card-header bg-white border-bottom-0 py-3">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <div className="d-flex align-items-center">
                                    <i className="bi bi-building text-primary fs-4 me-2"></i>
                                    <div className="card-title mb-0">Clinic Information</div>
                                </div>
                                <div>
                                    {isEditing ? (
                                        <button
                                            className="btn btn-danger btn-sm text-white"
                                            onClick={() => setIsEditing(false)}
                                            disabled={isLoading}
                                        >
                                            <i className="bi bi-x-circle"></i> Cancel
                                        </button>
                                    ) : (
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={() => setIsEditing(true)}
                                            disabled={isLoading}
                                        >
                                            <i className="bi bi-pencil-square me-1"></i> Edit
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="card-body">
                            {isLoading ? (
                                <div className="text-center py-4">
                                    <Loading/>
                                </div>
                            ) : (
                                <>
                                    {isEditing ? (
                                        <GatewayClinicInfoForm
                                            clinicInfo={clinicInfo}
                                            updateInfo={updateClinicInfo}
                                        />
                                    ) : (
                                        <GatewayClinicInfoText clinicInfo={clinicInfo}/>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* Sidebar - col-3 */}
                <div className="col-md-3">
                    <div className="card shadow-sm">
                        <div className="card-header bg-white py-3">
                            <div className="mb-0 card-title">
                                <i className="bi bi-link-45deg me-2"></i>
                                Quick Links
                            </div>
                        </div>
                        <div className="card-body p-5">
                            <div className="list-group list-group-flush">
                                <a
                                    href="sms-notifications"
                                    className="list-group-item list-group-item-action py-2 px-3 p-4"
                                >
                                    <i className="bi bi-bell-fill text-primary me-2"></i>
                                    Past Notifications
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GatewayClinicInfo;